import { useEffect } from 'react'
import { matchesHotkey } from '@/utils/keyboard-util'

/**
 * Registers a global hotkey. The key's default action is left alone, since
 * Esc handlers stay registered while there is nothing for them to close;
 * callbacks that do need it cancelled call `preventDefault()` on the event.
 *
 * @param hotkey
 * @param callback
 */
export function useHotkey(
  hotkey: string[],
  callback: (event: globalThis.KeyboardEvent) => unknown,
) {
  // Callers pass inline arrays, so the effect keys off their content.
  const hotkeyId = hotkey.join('+')

  useEffect(() => {
    const codes = hotkeyId.split('+')
    document.addEventListener('keydown', hotkeyHandler)

    return () => {
      document.removeEventListener('keydown', hotkeyHandler)
    }

    /**
     * Hotkey handler.
     * @param e
     */
    function hotkeyHandler(e: globalThis.KeyboardEvent) {
      if (matchesHotkey(codes, e)) {
        callback(e)
      }
    }
  }, [callback, hotkeyId])
}
